import React, { useEffect } from "react";
import "./App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { VideoShowcase } from "./components/VideoShowcase";
import { Projects } from "./components/Projects";
import { Services } from "./components/Services";
import { WhyChooseUs } from "./components/WhyChooseUs";
import { MissionVision } from "./components/MissionVision";
import { Founder } from "./components/Founder";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Chatbot } from "./components/Chatbot";
import { WhatsAppButton } from "./components/WhatsAppButton";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <VideoShowcase />
      <Projects />
      <Services />
      <WhyChooseUs />
      <MissionVision />
      <Founder />
      <Contact />
      <Footer />
      <Chatbot />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
}

export default App;
